import * as React from "react";

import "./summary-table.scss";

import {cs}           from "@Common/react/chain-services";
import {formatMoney1} from "@Common/ui-components/language/format-money";
import {cascadeSum}   from "@Common/utils/cascade";

import {CheckShowPricing} from "../../../../common/check-show-pricing";
import {InformationBadge} from "@Common/ui-components/heavy/common/design2/information-badge/information-badge";

export const SummaryTable = ({title, subtitle, lines, balance, explanations=[]}) => cs(
    ({}) => (
        <div className="table summary-table-75e">
            <div className="header">
                <div className="title" xd-qa-type="label" xd-qa-name={title}>
                    {title}
                </div>
                <div className="sub-title" xd-qa-type="label" xd-qa-name={title+" Description"}>
                    {subtitle}
                </div>
            </div>

            {cs(
                ({}, next) => CheckShowPricing({next}),
                () => (
                    <div className="table">
                        <div className="table-head" xd-qa-type="label" xd-qa-name="Cart Summary Amount Due">
                            AMOUNT DUE
                        </div>
                        <div className="sections">
                            <div className="section">
                                {lines.map(({label, amount, description, isCredit}, i) => (
                                    <div className="line" key={i}>
                                        <div className="label" xd-qa-type="label" xd-qa-name={"Cart Summary "+label}>
                                            {label}
                                            {description && amount != null &&
                                                (<span style={{marginLeft: "5px"}}>
                                                    {InformationBadge({
                                                        getTooltip: () => description,
                                                        xdQaName: "RDF",
                                                    })}
                                                </span>)

                                            }
                                        </div>
                                        <div className="amount" xd-qa-type="label" xd-qa-name={"Cart Summary "+label+" Amount"}>
                                            {isCredit && amount != null && (
                                                <span>-</span>
                                            )}
                                            {amount == null ? "--" : formatMoney1(amount)}
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div className="section">
                                <div className="total">
                                    <div className="label" xd-qa-type="label" xd-qa-name="Cart Summary Total">
                                        Total
                                    </div>
                                    <div className="amount" xd-qa-type="label" xd-qa-name="Cart Summary Total Amount">
                                        {balance == null ? "--" : formatMoney1(balance)}
                                    </div>
                                </div>
                                {!!explanations?.length && (
                                    <div className="explanations">
                                        {explanations.map(({label, amount}, i) => (
                                            <div className="explanation" key={i}>
                                                <div className="label" xd-qa-type="label" xd-qa-name={"Explanation"}>
                                                    {label}
                                                </div>
                                                <div className="amount" xd-qa-type="label" xd-qa-name={"Cart Summary "+label+" Amount"}>
                                                    {amount != null && (
                                                        <span>-</span>
                                                    )}
                                                    {amount == null ? "--" : formatMoney1(amount)}
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                )}
                                {!!explanations?.length && (
                                    <div className="line big">
                                        <div className="label" xd-qa-type="label" xd-qa-name="Cart Summary Balance Remaining">
                                            Balance Remaining
                                        </div>
                                        <div className="amount" xd-qa-type="label" xd-qa-name="Cart Summary Balance Remaining Amount">
                                            {formatMoney1(balance - cascadeSum(explanations, "[*].amount"))}
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                )
            )}
        </div>
    ),
);
